import { render, staticRenderFns } from "./BinCollectionScheduleTable.vue?vue&type=template&id=0af02ed2"
import script from "./BinCollectionScheduleTable.vue?vue&type=script&lang=js"
export * from "./BinCollectionScheduleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports